<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="d-none d-xl-block col-xl-3">
                    <catalog-categories></catalog-categories>
                </div>
                <div class="col-xl-9">
                    <div class="box-shadow">
                        <h1 class="as-h2 mb-28">Акции</h1>
                        <div class="grid-container">
                            <div class="box-grid" v-for="(item,i ) in shares_bd"
                                 :key="i">
                                <router-link class="box-grid"
                                             :to="'/promotions/' + item.slug">
                                    <img :src="'/storage/' + item.image" :alt="item.title">
                                    <!--                                <h4 class="color-text-white">{{item.title}}</h4>-->
                                </router-link>
                            </div>

                        </div>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                shares_bd: null,

                breadcrumb: [
                    {
                        text: 'Главная',
                        to: { name: 'pages-index' }
                    },
                    {
                        text: 'Акции',
                        active: true
                    }
                ],
                seo_text: null

            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                let url = '/api/shares';
                axios.get(url)
                    .then(response => {
                        this.shares_bd = response.data.shares

                        let seoInfo = response.data.seoInfo
                        this.seo_text = response.data.seoInfo.seo_text
                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Акции Фотопроката "MRental"';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Следите за нашими акциями и скидками. Самые выгодные предложения и спецпроекты.';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);

                    })
            },
        }
    }
</script>
